import React from 'react';
import PercentageBtn from './PercentageBtn';

type Props = {
  onChange: (value: number) => void;
  disabled?: boolean;
};

const PercentageBtns: React.FC<Props> = (props) => {
  const arrPercents = [25, 50, 75, 100];
  return (
    <div className="flex flex-row justify-between">
      {arrPercents.map((pct) => (
        <PercentageBtn
          key={pct}
          onChange={props.onChange}
          percent={pct}
          disabled={props.disabled}
        />
      ))}
    </div>
  );
};

export default PercentageBtns;
